import React, { useRef, useState } from 'react';
import { Stack, TextField, Typography, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../../core/Header/Header';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../Store/mainSlice';
import httpClient from '../../_util/api';
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar';
import ButtonMain from '../../components/Button';
import './style.css';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const snackbar_Ref = useRef();
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const handleSendLink = async () => {
        dispatch(showLoader());
        const res = await httpClient.post('/user/forgotPassword', { email }).catch((error) => {
            dispatch(hideLoader());
            snackbar_Ref.current.showMessage("error", error?.response?.data?.message || "Something went wrong", "", "i-chk-circle");
        });

        if (res?.status === 200) {
            dispatch(hideLoader());
            snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
        }
    };

    return (
        <Stack alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100vh', backgroundColor: '#f5f5f5' }}>
            <Header />
            <CustomizedSnackbars ref={snackbar_Ref} />
            <Card sx={{ width: 350, padding: 4, textAlign: 'center', borderRadius: 3, boxShadow: 3 }}>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    Forgot Password?
                </Typography>
                <Typography variant="body2" color="textSecondary" mb={2}>
                    Confirm your email address and we'll send you a link to securely reset it.
                </Typography>
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    onChange={(e) => setEmail(e.target.value)}
                />
                <ButtonMain
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleSendLink}
                >
                    Send Email
                </ButtonMain>
                <ButtonMain
                    variant="white"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={() => navigate('/')}
                >
                    Back to Login
                </ButtonMain>
            </Card>
        </Stack>
    );
};

export default ForgotPassword;
